import EditorContainerWrapper from 'components/EditorContainerWrapper';
import Dropdown from 'components/connectedForm/Dropdown';
import _get from 'lodash/get';
import fieldMetaData from 'graphql/schema/fieldMetaData.ts';

import QueryDropdown from 'components/connectedForm/QueryDropdown';
import MultiQueryDropdown from '../connectedForm/MultiQueryDropdown';
import DropdownLatest from '../connectedForm/DropdownLatest';

export default class DropdownEditor extends EditorContainerWrapper {
  constructor(props) {
    super(props);
    this.getOptions = this.getOptions.bind(this);
    this.getValueFromOption = this.getValueFromOption.bind(this);
  }

  // Decide which editor to use based on the attribute type of the current row
  getEditorComponent = () => {
    const { options } = this.props.column;
    if (options.dropdown?.enableMulti) {
      return MultiQueryDropdown;
    } else if (options.dropdown?.query) {
      return QueryDropdown;
    } else if (options.dropdown?.useLatestReactSelect) {
      return DropdownLatest;
    }
    return Dropdown;
  };

  // Set extra props, such as validation
  getEditorProps = () => {
    let editorProps = {};
    let options = this.getOptions();
    if (this.props.column.options && this.props.column.options.dropdown) {
      const {
        query,
        selectModal,
        valueRenderer,
        optionRenderer,
        filterOption,
        filterOptions,
        remoteFilter,
        valueKey,
        labelKey,
        valueField,
        dataField,
        displayFields,
        freeType,
        isEnum,
        clearable,
        shouldKeyDownEventCreateNewOption,
        newOptionCreator,
        promptTextCreator,
        predefinedFilters,
        menuRenderer,
        preLoad,
        additionalVariables,
      } = this.props.column.options.dropdown;

      const { searchTabOffset, searchEnterOffset } = this.props.column.options;

      editorProps.options = options;
      editorProps.filterOptions = filterOptions;
      editorProps.valueField = valueField;
      editorProps.dataField = dataField;
      editorProps.displayFields = displayFields;
      editorProps.freeType = freeType;
      editorProps.getValueFromOption = this.getValueFromOption;
      editorProps.inGrid = true;
      editorProps.valueKey = valueKey;
      editorProps.labelKey = labelKey;
      editorProps.dataid = this.props.column.key;
      editorProps.selectModal = selectModal;
      editorProps.newOptionCreator = newOptionCreator;
      editorProps.clearable = clearable;
      editorProps.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
      editorProps.promptTextCreator = promptTextCreator;
      if (optionRenderer) {
        editorProps.optionRenderer = optionRenderer;
      }
      if (valueRenderer) {
        editorProps.valueRenderer = valueRenderer;
      }
      if (query) {
        editorProps.options = null;
        editorProps.filterOption = filterOption;
        editorProps.remoteFilter = remoteFilter;
        editorProps.predefinedFilters = predefinedFilters;
        editorProps.preLoad = preLoad;
      } else if (isEnum) {
        editorProps.options = fieldMetaData[this.props.column.options.type].enumValues;
      }
      editorProps.searchTabOffset = searchTabOffset;
      editorProps.searchEnterOffset = searchEnterOffset;
      editorProps.menuRenderer = menuRenderer;
      editorProps.additionalVariables = additionalVariables;
    }
    return editorProps;
  };

  onChange = (newValue, keyCode, { skipTabBehaviour } = {}) => {
    let update = newValue;
    if (this.props.column.options && this.props.column.options.dropdown) {
      const { isEnum } = this.props.column.options.dropdown;
      if (isEnum) update = newValue.value;
    }
    this.setState({ currentValue: update, lastKeyCode: keyCode }, () => {
      this.props.onCommit(undefined, { skipTabBehaviour });
      //Try to preserve previous functionality (May not be required).
      //Previously, updateCellState was called from higher up the chain, but this caused components to unmount before the commit could be completed.
      //so have moved it to here so we don't lose our selection.
      this.props.updateCellState({
        modalOpen: false,
      });
    });
  };

  getKey = () => {
    return this.props.column.key;
  };

  getValue() {
    let updated = {};
    let value = this.state.currentValue === '' ? null : this.state.currentValue;
    updated[this.props.column.key] = value;

    if (this.getKey) {
      if (updated[this.getKey()]) updated[this.getKey()] = value;
    }

    const { entityType, entityId, entityDisplay } = this.props.column.options;
    updated.entityType = entityType;
    updated.idPath = entityId;
    updated.displayPath = entityDisplay;
    updated.idValue = value;
    updated.lastKeyCode = this.state.lastKeyCode;
    return updated;
  }

  getOptions() {
    const { options } = this.props.column;
    if (options && options.dropdown) {
      if (typeof options.dropdown.options === 'function') {
        return options.dropdown.options();
      }
      if (options.dropdown.options) {
        return _get(this.props.rowData, options.dropdown.options);
      }
      return this.props.rowMetaData && this.props.rowMetaData.options ? this.props.rowMetaData.options : null;
    } else {
      return null;
    }
  }

  getValueFromOption(option) {
    let value = null;
    if (this.props.column.options && this.props.column.options.dropdown) {
      value = _get(option, this.props.column.options.dropdown.valueField);
    }
    this.setState(Object.assign({}, { currentValue: value }));
  }
}
